<template>
	<div>
		<b-button :variant="btn_variant" :size="size" @click.stop="printStart">
            <slot>
            </slot>
        </b-button>
        
        <template v-if="print_started">
            <div :key="start_key" style="margin-left: -9999px; margin-top:-9999px; width: 1100px; position:absolute;">
                <div id="printout">
                <div :class="is_printing? 'printing px-5' : 'not_printing'">
                    <div class="d-flex align-items-center justify-content-between" style="height:80px;">      
                        <b-img :src="titleImg" alt="QESG Assessment" style="width: 110px;"></b-img>          
                        <div class="gray-600 f-90"> QESG Assessment / {{ answer_company.company_name }}</div>
                    </div>
                    <h2 class="fw-600 mb-5 py-5 px-5 teal8 bg-tealgray200"> {{ answer_company.campaign_name }} {{ print_mode == 'question_and_audit' ? $t('답변 및 평가 결과') : $t('질문지') }}</h2>
                    <hr class="border-0 py-3">

                    <template v-if="print_target_questions.length && (print_mode == 'only_question' || is_qe_evaluate_loaded)">
                        <div v-for="(question_code_item, index) in rendered_questions" :key="question_code_item">
                            <template v-if="print_mode == 'only_question'">
                                <questions-for-print
                                    class="text-left"
                                    :question_code="question_code_item"
                                    :is_final_question_code="index === print_target_questions.length - 1"
                                    @load-finished="handleLoadFinished"
                                    @load-error="handlePrintError"
                                    >
                                </questions-for-print>
                            </template>
                            <template v-else-if="print_mode == 'question_and_audit'" >
                                <answers-for-print
                                    class="text-left"
                                    :question_code="question_code_item"
                                    :is_final_question_code="index === print_target_questions.length - 1"
                                    @load-finished="handleLoadFinished"
                                    @load-error="handlePrintError"
                                    >
                                </answers-for-print>
                            </template>
                        </div>
                    </template>
                    
<!--                    <div class="px-8 py-5 bgray-300" >    -->
<!--                        <div class="f-85 mb-3" :class="$i18n.locale=='en'?'':'pt-3'">-->
<!--                                <div class="fw-300 mb-2">{{$t(`copyright 2025. ㈜퀀티파이드이에스지, all rights reserved.`)}} </div>-->
<!--                                <div class="fw-300 mb-2">-->
<!--                                    {{$t(`본 문서에 게재된 평가 질문 문항 정보, 질문지 레이아웃을 포함한 모든 정보는 저작권법에 의하여 보호받는 저작물로 그 저작권은 ㈜퀀티파이드이에스지에 있습니다. 따라서 본 보고서에 대한 무단 복제, 전체, 배포를 원칙적으로 금지합니다. 또한 본 문서를 통해 수익을 얻거나 이에 상응하는 혜택을 누리고자 하는 경우 ㈜퀀티파이드이에스지와 사전에 별도 서면 협의를 거쳐야 하며, 협의가 완료된 후에도 해당 보고서의 내용을 게재하는 경우 출처가 ㈜퀀티파이드이에스지임을 밝혀야 합니다.`)}}-->
<!--                                </div>-->
<!--                                <div class="fw-300 ">-->
<!--                                    <template v-if="$i18n.locale=='ko'">본 문서에 게재된 정보 또는 위와 관련한 사항에 대한 보다 자세한 정보는 <a href="http://qesg.co.kr/" target="_blank">qesg.co.kr</a>에 문의해 주십시오.</template>-->
<!--                                    <template v-else>Please contact <a href="http://qesg.co.kr/" target="_blank">qesg.co.kr</a> for more detailed information on the information presented in this report or related to the above. </template>-->
<!--                                </div>-->
<!--                        </div>-->
<!--                        <div class="text-right">-->
<!--                            <b-img src="/images/QuantifiedESG_Logo_v3_Basic.svg" style="width: 110px;"></b-img>          -->
<!--                        </div>-->
<!--                    </div>-->
                </div>

                </div> <!-- print_out div-->
            </div>
        </template>
        

		<b-modal id="pdf_down_modal" size="lg" hide-footer @show="is_printing=true" @hide="is_printing=false">
            <template v-slot:modal-title>
                <span>{{ $t('출력하기') }}</span>
            </template>
            <div v-if="print_error" class="text-center py-3">
                <p class="text-danger fw-500">{{ print_error }}</p>
                <b-btn v-if="print_timed_out" class="mr-2" variant="blue" @click="markPrintReady">{{ $t('그대로 출력') }}</b-btn>
                <b-btn variant="dark-border" @click="retryPrint">{{ $t('다시 시도') }}</b-btn>
            </div>
            <div v-else-if="is_preparing" class="text-center py-3">
                <b-spinner small class="mr-2"></b-spinner> {{ $t('출력할 문항을 확인하고 있습니다.') }}
            </div>
            <div v-else-if="print_mode == 'not_determined'">
                <template v-if="check_access_lv">
                    <div class="mt-2 mb-4 text-center fw-500">{{ $t('출력물에 상세평가(Audit) 내용을 포함하시겠습니까?') }}</div>
                    <div class="text-center mb-3">
                        <b-btn class="mr-3" variant="dark-border"
                            @click="print_mode = 'question_and_audit'"
                            >
                            {{ $t('예, 포함합니다.') }}
                        </b-btn>
                        <b-btn variant="dark-border" @click="print_mode = 'only_question'">
                            {{ $t('아니오, 질문과 답변만 필요합니다.') }}
                        </b-btn>
                    </div>   
                </template>
                <template v-else>
                    <b-button variant="blue" @click="print_mode = 'only_question'">
                        {{ answer_company.company_name }}
                        {{ $t('답변지 출력하기') }}
                    </b-button>
                </template>
            </div>
            <div v-else>
                <div class="d-block text-center">
                    <div class="pb-3">
                        <b-progress :value="progress_rate" :max="100" show-progress animated /> 
                    </div>

                    <div v-if="print_ready!=true">
                        <div class="d-flex align-items-center justify-content-center"> <b-spinner small class="mr-2" type="grow"></b-spinner>  {{ msg }}</div>
                    </div>
                    <div v-else class="mt-3">
                        <p class="text-left fw-500"> {{$t(`PDF로 다운로드 하실 경우 아래 설명을 확인 후 진행해 주세요.`)}}</p>

                        <b-tabs content-class="bg-white pt-3 pb-4 mb-4">
                            <b-tab :title="$t(`크롬(Google Chrome) 사용중인 경우`)" active>
                                <b-img :src="$i18n.locale=='en'?'/images/how_to_print_chrome_en.png':'/images/how_to_print_chrome.png'" :alt="$t('크롬 인쇄 창에서 대상은 PDF로 저장, 여백은 없음으로 고르고 배경 그래픽을 체크한 뒤 저장을 누릅니다.')" fluid style="max-width: 90%"></b-img>
                            </b-tab>
                            <b-tab :title="$t(`엣지(Microsoft Edge) 사용중인 경우`)">
                                <b-img :src="$i18n.locale=='en'?'/images/how_to_print_edge_en.png':'/images/how_to_print_edge.png'" :alt="$t('엣지 인쇄 창에서 프린터는 PDF로 저장, 여백은 없음으로 고르고 배경 그래픽을 체크한 뒤 저장을 누릅니다.')" fluid style="max-width: 90%"></b-img>
                            </b-tab>
                        </b-tabs>
                        <b-button v-if="isIE!=true" v-print="'#printout'" variant="blue">{{ $t('PDF 인쇄 / 다운로드') }}</b-button>
                        <b-button v-else variant="blue" @click="pdf.save('company_report.pdf')">{{ $t('PDF 다운로드') }}</b-button>
                    </div>
                </div>                
            </div>
            <b-button class="float-right" variant="dark" @click="cancel()">{{ $t('취소') }}</b-button>
		</b-modal>
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import QuestionsForPrint from '@shared_components/client/components/QuestionsForPrint';
import AnswersForPrint from '@shared_components/admin/components/common/AnswersForPrint';
import * as th from 'tree-helper';
import titleImg from '@shared/assets/img/common/QuantifiedESG_Logo_v3_Basic.png';

export default {
    name: 'AuditPrintButton',
    props: {
        btn_variant: {
            type: String,
            default: 'dark-border'
        },
        size: {
            type: String,
            default: ''
        }
    },
    components: {
        QuestionsForPrint,
        AnswersForPrint
    },
    data () {
        return {
            print_target_questions: [],
            start_key: Math.random()*1000,
            propTitle: 'mypdf',
            print_started: false,
            print_ready: false,
            pdf: '',
            // print_target_questions_started: [],
            print_target_questions_loaded: [],
            msg: this.$t('PDF 파일 준비중... 최대 1분 정도 소요될 수 있습니다.'),
            is_printing: false,
            print_mode: 'not_determined',
            is_preparing: false,
            print_error: '',
            qe_load_error: false,
            load_timer: null,
            print_timed_out: false,
            render_all: false,
            titleImg
        };
    },
    computed:{
        ...mapState(['template_tree', 'campaign', 'is_admin','company_id']),
        ...mapState('questions',['answer_company']),
        ...mapState('score', ['is_evaluate_loaded']),
        ...mapState('industry_scores', ['is_qe_evaluate_loaded']),
        target_template_contents(){
            if (this.view_mode=='provider') {
                return this.template_in_progress.template_contents;
            } else {
                return this.template_tree.template_contents;
            }
        },   
        
        num_of_print_target_questions () {
            // return this.print_target_questions.length * 2
            return this.print_target_questions.length;
        },
        // num_of_print_target_questions_started(){
        // 	return this.print_target_questions_started.length
        // },
        num_of_print_target_questions_loaded () {
            return this.print_target_questions_loaded.length;
        },
        // 문항마다 /subs 를 부르므로 한 번에 5개까지만 그리고, 하나 끝날 때마다 다음 문항을 그린다
        rendered_questions () {
            if (this.render_all) return this.print_target_questions;
            return this.print_target_questions.slice(0, this.num_of_print_target_questions_loaded + 5);
        },
        progress_rate () {
            // return ((this.num_of_print_target_questions_loaded + this.num_of_print_target_questions_started) / this.num_of_print_target_questions) * 100
            if (!this.num_of_print_target_questions) return 0;
            return (this.num_of_print_target_questions_loaded / this.num_of_print_target_questions) * 100;
        },
        check_access_lv(){
            return this.is_admin == 4 || [405, 2948].includes(this.company_id);
        }	
    },
    watch:{
        print_started () {
            this.armLoadTimer();
        },
        qe_load_error (_failed) {
            if (_failed && this.print_mode == 'question_and_audit') {
                this.print_error = this.$t('평가 결과를 불러오지 못했습니다. 평가 내용 없이 질문과 답변만 출력하거나 다시 시도해주세요.');
            }
        },
        print_mode (_mode) {
            this.armLoadTimer();
            if (_mode == 'question_and_audit' && this.qe_load_error) {
                this.print_error = this.$t('평가 결과를 불러오지 못했습니다. 평가 내용 없이 질문과 답변만 출력하거나 다시 시도해주세요.');
            }
        },
        async progress_rate (new_value) {
            if (new_value >= 100) {
                await this.markPrintReady();
            }
        },
        is_printing (_printing_status) {
            if (!_printing_status) {
                this.initializePrintButton();
            }
        }
    },
    async created () {
        this.initializePrintButton();

        if(this.is_evaluate_loaded==false){
            await this.$store.dispatch('score/readAllEvaluateResult', {
                campaign_id: this.answer_company.campaign_id,
                company_name: this.answer_company.company_name,
                project_code: this.answer_company.project_code
            });
        }
    },
    beforeDestroy () {
        this.initializePrintButton();
        clearTimeout(this.load_timer);
    },
    methods: {
        ...mapActions('industry_scores', ['readQeEvaluateResult']),
        async printStart () {
            this.$bvModal.show('pdf_down_modal');
            if (!this.print_started && !this.is_preparing) {
                this.print_error = '';
                this.is_preparing = true;
                try {
                    await this.initiatePrintTargetQuestions();
                    this.print_target_questions_loaded = [];
                    if (!this.print_target_questions.length) {
                        this.print_error = this.$t('출력할 문항이 없습니다.');
                    } else {
                        this.print_started = true;
                    }
                } catch (error) {
                    console.error(error);
                    this.print_error = this.$t('출력 준비 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.');
                } finally {
                    this.is_preparing = false;
                }
            }
        },
        retryPrint () {
            this.initializePrintButton();
            this.printStart();
        },
        async markPrintReady () {
            if (this.print_ready) return;
            clearTimeout(this.load_timer);
            // 지연 안내만 지운다 — 평가 결과·답변 실패 안내는 출력 준비가 끝나도 남긴다
            if (this.print_timed_out) this.print_error = '';
            if(this.isIE) this.pdf = await this.makePDF('#printout');
            this.print_ready = true;
            this.msg = this.$t('출력 준비가 완료되었습니다.');
        },
        handlePrintError () {
            this.print_timed_out = false;
            this.print_error = this.$t('일부 문항의 답변을 불러오지 못했습니다. 다시 시도해주세요.');
        },
        // 출력 방식을 고른 뒤 진행이 멈추면: 아직 안 그린 문항이 있으면 20초 뒤 나머지를 한꺼번에 그리고
        // (완료 신호가 오지 않는 문항이 5개 자리를 모두 잡은 경우), 다 그렸는데도 90초 동안 진행이 없으면 지연으로 안내한다
        armLoadTimer () {
            clearTimeout(this.load_timer);
            if (this.print_started && !this.print_ready && this.print_mode != 'not_determined') {
                const _slots_stalled = this.rendered_questions.length < this.print_target_questions.length;
                this.load_timer = setTimeout(() => {
                    if (!this.print_started || this.print_ready || this.print_error) return;
                    if (_slots_stalled) {
                        this.render_all = true;
                        this.armLoadTimer();
                        return;
                    }
                    this.print_timed_out = true;
                    this.print_error = this.$t('출력 준비가 지연되고 있습니다. 그대로 출력하면 아직 불러오지 못한 문항은 비어 있을 수 있습니다.');
                }, _slots_stalled ? 20000 : 90000);
            }
        },
        async initiatePrintTargetQuestions () {
            this.print_target_questions = [];
            this.qe_load_error = false;
            await Promise.all([
                this.readQeEvaluateResult({
                    campaign_id: this.answer_company.campaign_id,
                    company_id: this.answer_company.company_id,
                    project_code: this.answer_company.project_code
                })
                    .catch(e=>{
                        console.error(e);
                        this.qe_load_error = true;
                    }),
                this.$store.dispatch('makeTemplateTreeByCompanyId', {
                    campaign_id: this.answer_company.campaign_id,
                    company_id: this.answer_company.company_id
                })
            ]);
            
            let template_contents = this.target_template_contents;
            let temp_print_target = [];
            th.breadthFirstSearch(template_contents, node => {
                if(typeof node.children == 'undefined' || node.children.length == 0){
                    temp_print_target.push(node.question_code);
                }
            });
            
            // 같은 문항이 두 번 들어가면 완료 수가 문항 수에 못 미쳐 준비가 끝나지 않는다
            this.print_target_questions = [...new Set(temp_print_target)];
        },
        async makePDF (sel) {
            window.html2canvas = html2canvas; //Vue.js 특성상 window 객체에 직접 할당해야한다.
            let pdf = new jsPDF('p', 'mm', 'a4');

            let canvas = pdf.canvas;
            const pageWidth = 210; //캔버스 너비 mm
            const pageHeight = 295; //캔버스 높이 mm
            canvas.width = pageWidth;

            let ele = document.querySelector(sel);
            let width = ele.offsetWidth; // 셀렉트한 요소의 px 너비
            let height = ele.offsetHeight; // 셀렉트한 요소의 px 높이
            let imgHeight = pageWidth * height/width; // 이미지 높이값 px to mm 변환

            if (!ele) {
                console.warn(sel + ' is not exist.');
                return false;
            }
            const _converted = await html2canvas(ele);
            let position = 0;
            const imgData = _converted.toDataURL('image/png');
            pdf.addImage(imgData, 'png', 0, position, pageWidth, imgHeight, undefined, 'slow');

            // Paging 처리
            let heightLeft = imgHeight; // 페이징 처리를 위해 남은 페이지 높이 세팅.
            heightLeft -= pageHeight;
            while (heightLeft >= 0) {
                position = heightLeft - imgHeight;
                pdf.addPage();
                pdf.addImage(imgData, 'png', 0, position, pageWidth, imgHeight);
                heightLeft -= pageHeight;
            }
            
            return pdf;	
        },
        cancel () {
            this.initializePrintButton();
            this.$bvModal.hide('pdf_down_modal');
        },
        initializePrintButton () {
            this.print_started = false;
            this.print_ready = false;
            this.is_printing = false;
            this.print_target_questions = [];
            this.print_target_questions_loaded = [];
            this.print_mode = 'not_determined';
            this.print_error = '';
            this.print_timed_out = false;
            this.render_all = false;
            clearTimeout(this.load_timer);
            this.msg = this.$t('PDF 파일 준비중... 최대 1분 정도 소요될 수 있습니다.');
        },
        handleLoadFinished (question_code){
            if (!this.print_target_questions_loaded.includes(question_code)) {
                this.print_target_questions_loaded.push(question_code);
            }
            this.armLoadTimer();
        }
    }
};
</script>
<style scoped>
.printing{
	display: block;
}

.not_printing{
	display: none;
}
</style>
